import React from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TablePaginationActions from '../../../shared/components/Table/Actions';
import Button from '@mui/material/Button';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    novoRegistro: {
        marginTop: '10px',
        marginBottom: '20px',
    },
    cursorLink: {
        cursor: 'pointer'
    }
});


export default function AlunoLivroTableAdd({ alunosLivros, handleChangePage, setAlunoLivro, livroAutor }) {
    const classes = useStyles();

    return (
        <div>
            <Button
                onClick={() => setAlunoLivro({
                    eNovo: true,
                    livro: livroAutor.livro
                })}
                variant="contained"
                color="primary"
                className={classes.novoRegistro}
            >
                Novo Aluno Livro
            </Button>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell>Nome Aluno</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {alunosLivros.content.map((alunoLivro) => (
                        alunoLivro && alunoLivro.codigo ?
                            <TableRow key={alunoLivro.codigo}>
                                <TableCell>{alunoLivro.aluno.nome}</TableCell>
                            </TableRow> : null
                    ))}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[]}
                rowsPerPage={alunosLivros.size ? alunosLivros.size : 0}
                component="div"
                count={alunosLivros.totalElements}
                page={alunosLivros.number}
                onPageChange={handleChangePage}
                labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : " mais de " + to))}
                ActionsComponent={TablePaginationActions}
            />
        </div>
    );
}